import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Landingpage from '../views/Landingpage'

import Form from '../views/checkout/Form'
import ConditionCheck from '../views/checkout/ConditionCheck'
import PersonalData from '../views/checkout/PersonalData'
import Overview from '../views/checkout/Overview'
import Cart from '../views/cart/Cart'
import Success from '../views/cart/Success'
import Error from '../views/cart/Error'
import Help from '../views/help/Help'

import Diagnosis from '../views/diagnosis/Diagnosis'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landingpage',
    component: Landingpage,
    alias: '/online-reparaturannahme'
  },
  {
    path: '/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/diagnose',
    name: 'Diagnosis',
    component: Diagnosis
  },
  {
    path: '/ergebnis',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/auftragsbestaetigung',
    name: 'Success',
    component: Success
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    name: 'Form',
    path: '/online-reparaturannahme/',
    component: Form,
    children: [
      { name: 'ConditionCheck', path: 'zustand', component: ConditionCheck },
      { name: 'PersonalData', path: 'persoenliche-daten', component: PersonalData },
      { name: 'Overview', path: 'auftragsuebersicht', component: Overview }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const paths = routes[routes.length - 1].children
  const toIndex = paths.findIndex(route => route.name === to.name) ?? 0
  const fromIndex = paths.findIndex(route => route.name === from.name) ?? 0

  if (!to.matched.length) {
    next({ name: 'Landingpage' })
  } else {
    // wenn zurück oder nicht checkout oder wenn 1 schritt vor und valide
    if (fromIndex > toIndex || toIndex < 1 || (Math.abs(fromIndex - toIndex) <= 1 && store.state.validation && !store.state.validation.$invalid)) {
      store.commit('setCurrentStep', toIndex)
      next()
    }
  }
})

export default router
